import React, { useContext } from 'react'
import { LikutModals } from '../../../../../modules/Context/CefiNum'
import { AppModal } from '../../../../../generic/ui/Modal'
import MoreThenNeed from './MoreThenNeed'
import SuccessModal from './SuccessModal'
import useReasonsLikut from '../useReasonsLikut'

export default function ModalContainer() {
    const [resonState, setResonState] = useContext(LikutModals);
    const likutResons = useReasonsLikut()

    if (!resonState?.active || !resonState?.resonTag) return null

    const closeModal = () => setResonState({ ...resonState, 'active': false })

    if (resonState.resonTag === 'success') {
        return (
            <AppModal
                title={resonState?.props?.title || 'WOW!'}
                controlFunc={closeModal}
                Children={SuccessModal}
                childrenProps={{
                    title: resonState?.props?.title,
                    text: resonState?.props?.text,
                    mood: resonState?.props?.mood,
                }}
                size='sm'
            />
        )
    }

    const resons = likutResons[resonState.resonTag]
    if (!resons) return null

    return (
        <AppModal
            title={resons?.tag || ''}
            controlFunc={closeModal}
            Children={MoreThenNeed}
            childrenProps={{ resons }}
            size='sm'
        />
    )
}
